import { AuthBaseClient } from '../base-client';
import type { OrganizationResponse, UpdateOrganizationRequest, SchedulingContext } from './types';

/**
 * Client for organization API endpoints.
 */
export class OrganizationClient extends AuthBaseClient {
  /**
   * Get current organization.
   */
  async getCurrent(): Promise<OrganizationResponse> {
    return this.get<OrganizationResponse>('/api/organizations/current');
  }

  /**
   * Update current organization.
   */
  async update(data: UpdateOrganizationRequest): Promise<OrganizationResponse> {
    return this.patch<OrganizationResponse>('/api/organizations/current', data);
  }

  /**
   * Get scheduling context for the organization.
   * Returns the practice's timezone, current date, and earliest schedulable date.
   */
  async getSchedulingContext(): Promise<SchedulingContext> {
    return this.get<SchedulingContext>('/api/organizations/scheduling-context');
  }
}
